// ═══════════════════════════════════════════════════════════════
// Catalogue des features modulaires (UI)
// ═══════════════════════════════════════════════════════════════
// Doit rester synchronisé avec backend/src/lib/features.js.
// Le SUPERADMIN active/désactive ces modules par tenant.
// ═══════════════════════════════════════════════════════════════

export const FEATURES = {
  LOTS: 'lots',
  HACCP: 'haccp',
  CASHMAG: 'cashmag',
  OCR_INVOICES: 'ocr',
  TRANSFERS: 'transfers',
  REORDER: 'reorder',
  STOCK_VALUATION: 'stock-valuation',
  PRODUCTION: 'production',
  STOCK_ZONES: 'stock-zones',
  BAR_DISCO: 'bar-disco',
  WHATSAPP: 'whatsapp',
  BUTCHERY: 'butchery',
  ASSISTANT: 'assistant',
  SELLING_PRICE: 'selling-price',
  RECALLS: 'recalls',
  ESTABLISHMENT_STOCK_SETTINGS: 'establishment-stock-settings',
  INTERNAL_ORDERS: 'internal-orders',
  HUBRISE: 'hubrise',
};

// Liste ordonnée pour l'UI (multi-select dans la modal SUPERADMIN).
// Les clés i18n vivent dans locales/{fr,en}.json sous `features.<code>.label/desc`.
export const FEATURE_CATALOG = [
  { code: 'lots',            i18nKey: 'features.lots' },
  { code: 'transfers',       i18nKey: 'features.transfers' },
  { code: 'reorder',         i18nKey: 'features.reorder' },
  { code: 'stock-valuation', i18nKey: 'features.stockValuation' },
  { code: 'production',      i18nKey: 'features.production' },
  { code: 'stock-zones',     i18nKey: 'features.stockZones' },
  { code: 'bar-disco',       i18nKey: 'features.barDisco' },
  { code: 'haccp',           i18nKey: 'features.haccp' },
  { code: 'cashmag',         i18nKey: 'features.cashmag' },
  { code: 'ocr',             i18nKey: 'features.ocr' },
  { code: 'whatsapp',        i18nKey: 'features.whatsapp' },
  { code: 'butchery',        i18nKey: 'features.butchery' },
  { code: 'assistant',       i18nKey: 'features.assistant' },
  { code: 'selling-price',   i18nKey: 'features.sellingPrice' },
  { code: 'recalls',         i18nKey: 'features.recalls' },
  { code: 'establishment-stock-settings', i18nKey: 'features.establishmentStockSettings' },
  { code: 'internal-orders', i18nKey: 'features.internalOrders' },
  { code: 'hubrise',         i18nKey: 'features.hubrise' },
];

// Helper réutilisable côté composants
export function tenantHasFeature(tenant, code) {
  if (!tenant?.features) return false;
  return tenant.features.includes(code);
}

// Périmètre OCR réglé par le SUPERADMIN (miroir de backend/src/lib/ocr-scope.js).
export const OCR_SCOPES = ['both', 'delivery_notes', 'invoices'];

// Scan OCR autorisé pour ce type de document ('delivery_notes' | 'invoices') :
// option 'ocr' active ET type couvert par tenant.ocrScope (absent = les deux).
export function tenantOcrAllows(tenant, kind) {
  if (!tenantHasFeature(tenant, 'ocr')) return false;
  const scope = OCR_SCOPES.includes(tenant?.ocrScope) ? tenant.ocrScope : 'both';
  return scope === 'both' || scope === kind;
}
